import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, FileText, Menu as MenuIcon, User as UserIcon } from "lucide-react";

/**
 * MobileBottomNav — tab bar untuk primary navigation di mobile.
 * Hanya tampil di breakpoint < md.
 * 4 tabs: Dashboard, Vendor, Transaksi (opens drawer), Menu (opens drawer).
 */
export const MobileBottomNav = ({ onOpenMenu, onOpenTransaksi }) => {
    const loc = useLocation();
    const nav = useNavigate();

    const isActive = (p) => loc.pathname.startsWith(p);
    const transaksiPaths = ["/bon-kain", "/bon-peralatan", "/setor-barang", "/qc", "/reject-perbaikan", "/kasbon", "/invoice", "/spk"];
    const isTransaksiActive = transaksiPaths.some((p) => loc.pathname.startsWith(p));

    const tabCls = (active) =>
        `flex flex-col items-center justify-center gap-0.5 flex-1 py-1.5 transition-colors ${
            active ? "text-[var(--apple-blue)]" : "text-[var(--text-muted)] hover:text-[var(--text-primary)]"
        }`;

    return (
        <nav
            className="md:hidden fixed bottom-0 left-0 right-0 z-40 flex items-stretch"
            style={{
                height: "var(--bottom-nav-h)",
                background: "#fff",
                borderTop: "1px solid var(--border)",
                paddingBottom: "env(safe-area-inset-bottom)",
            }}
            data-testid="mobile-bottom-nav"
        >
            <button
                className={tabCls(isActive("/dashboard"))}
                onClick={() => nav("/dashboard")}
                data-testid="mobnav-dashboard"
            >
                <LayoutDashboard className="w-5 h-5" />
                <span className="text-[10px] font-medium">Dashboard</span>
            </button>
            <button
                className={tabCls(isActive("/vendor") || isActive("/master-vendor"))}
                onClick={() => nav("/vendor")}
                data-testid="mobnav-vendor"
            >
                <Users className="w-5 h-5" />
                <span className="text-[10px] font-medium">Vendor</span>
            </button>
            <button
                className={tabCls(isTransaksiActive)}
                onClick={onOpenTransaksi}
                data-testid="mobnav-transaksi"
            >
                <FileText className="w-5 h-5" />
                <span className="text-[10px] font-medium">Transaksi</span>
            </button>
            <button
                className={tabCls(false)}
                onClick={onOpenMenu}
                data-testid="mobnav-menu"
            >
                <MenuIcon className="w-5 h-5" />
                <span className="text-[10px] font-medium">Menu</span>
            </button>
        </nav>
    );
};

export default MobileBottomNav;
